import { Component, OnInit } from '@angular/core';
import { CertificateService } from '@app/services/certificates/certificate.service';
import { OAuth2Service } from '@app/services/oauth2.service';
import { UserSession } from '@app/store/models/session.model';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { LocalStorageService } from 'ngx-webstorage';

const NTF_002_ERROR_CODE = 'MS_NTF_002';

@Component({
    selector: 'app-error-modal',
    templateUrl: './error-modal.component.html',
    styleUrls: ['./error-modal.component.scss'],
    standalone: false
})
export class ErrorModalComponent implements OnInit {
  public modalRef: BsModalRef | undefined;

  errorCode: string = '';
  title: string = '';
  errorMessage: string = '';
  correlationId: string = '';
  correlationIdMessage: string = '';
  message: string = '';
  constructor(
    private bsModalService: BsModalService,
    private translateService: TranslateService,
    private oAuth2Service: OAuth2Service,
    private certificateService: CertificateService,
    private localStorageService: LocalStorageService
  ) {}

  get isNtf002Error(): boolean {
    return this.errorCode === NTF_002_ERROR_CODE;
  }

  ngOnInit(): void {
    this.errorCode = sessionStorage.getItem('errorCode') ?? '';

    if (this.isNtf002Error) {
      this.title = this.translateService.instant('ERROR_MODAL.MS_NTF_002_TITLE');
      this.errorMessage = this.translateService.instant('SERVER_ERRORS.MS_NTF_002_NEW', {
        username: this.resolveUsername(),
      });
    } else {
      this.title = this.translateService.instant('ERROR_MODAL.ERROR_TITLE');
      this.errorMessage = sessionStorage.getItem('errorMessage');
    }

    this.correlationId = localStorage.getItem('correlationId');
    this.correlationIdMessage = this.translateService.instant(
      'ERROR_MODAL.ERROR_CODE',
      {
        errorCode: this.correlationId,
      }
    );
    this.message = this.errorMessage + '. <br><br> ' + this.correlationIdMessage;
  }

  close() {
    this.bsModalService.hide('error');
    sessionStorage.removeItem('errorMessage');
  }

  //reindirizza alla pagina di login di ISAC per accedere con un'altra utenza
  changeUser() {
    this.close();
    this.oAuth2Service.login();
  }

  //apre il portale di assistenza in una nuova scheda
  contactSupport() {
    window.open(this.translateService.instant('URLS.CONTACT_SUPPORT_URL'), '_blank');
  }

  private resolveUsername(): string {
    const session = this.localStorageService.retrieve(
      'session'
    ) as UserSession | null;
    const userInfo = session?.userInfo;

    if (userInfo?.identity) {
      return userInfo.identity;
    }

    if (userInfo?.username) {
      return userInfo.username;
    }

    if (this.certificateService.certID) {
      return this.certificateService.certID;
    }

    const rawIdToken = this.oAuth2Service.idToken;
    if (rawIdToken) {
      const idToken = this.oAuth2Service.decodeToken(rawIdToken) as Record<
        string,
        string
      >;
      return (
        idToken?.['identity'] ||
        idToken?.['preferred_username'] ||
        idToken?.['sub'] ||
        ''
      );
    }

    return '';
  }
}
